<script setup lang="ts">
const layout = useLayout();
const formStore = useFormStore();

defineProps<{
  formData: UmbracoFormData;
  isFormValid: boolean;
}>();
</script>

<template>
  <div
    v-for="(page, pageIndex) in formData.pages"
    :key="`page-${pageIndex}`"
    class="bg-white-pure py-8 lg:rounded-textarea lg:py-12"
    :class="layout.isDesktop ? 'px-16' : 'container'"
  >
    <div
      v-for="(fieldset, fieldsetIndex) in page.fieldsets"
      :key="`fieldset-${fieldsetIndex}`"
    >
      <div
        v-for="(column, columnIndex) in fieldset.columns"
        :key="`column-${columnIndex}`"
        class="flex flex-col gap-6"
      >
        <div
          v-for="(field, fieldIndex) in column.fields"
          :key="`field-${fieldIndex}`"
          class="flex"
        >
          <BaseFormField :field="field" />
        </div>
      </div>
    </div>

    <BaseButton
      class="mt-6"
      :title="$t('FormMessages.General.Submit')"
      type="submit"
      :disabled="!isFormValid || formStore.isDisabled"
    />
  </div>
</template>
